import { render, staticRenderFns } from "./chargeDetail.vue?vue&type=template&id=96ba45ca&scoped=true&"
import script from "./chargeDetail.vue?vue&type=script&lang=js&"
export * from "./chargeDetail.vue?vue&type=script&lang=js&"
import style0 from "./chargeDetail.vue?vue&type=style&index=0&id=96ba45ca&scoped=true&lang=css&"
import style1 from "./chargeDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ba45ca",
  null
  
)

export default component.exports